/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type DisconnectSlackDirectoryConnectionRequestBody = {
  /**
   * Generation last read by the administrator.
   */
  generation: string;
  /**
   * Durable organization workspace connection ID.
   */
  id: string;
};

/** @internal */
export type DisconnectSlackDirectoryConnectionRequestBody$Outbound = {
  generation: string;
  id: string;
};

/** @internal */
export const DisconnectSlackDirectoryConnectionRequestBody$outboundSchema:
  z.ZodMiniType<
    DisconnectSlackDirectoryConnectionRequestBody$Outbound,
    DisconnectSlackDirectoryConnectionRequestBody
  > = z.object({
    generation: z.string(),
    id: z.string(),
  });

export function disconnectSlackDirectoryConnectionRequestBodyToJSON(
  disconnectSlackDirectoryConnectionRequestBody:
    DisconnectSlackDirectoryConnectionRequestBody,
): string {
  return JSON.stringify(
    DisconnectSlackDirectoryConnectionRequestBody$outboundSchema.parse(
      disconnectSlackDirectoryConnectionRequestBody,
    ),
  );
}
